import React, { useEffect, useRef, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Redirect } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Footer from "./Footer.js";
import NewHeader from "./newHeader.js";
import Stepper from "./Stepper";
import * as myConstClass from "./constant.js";
import "./address.css";
import AddressCarousel from "./components/AddressCarousel.jsx";
import FixedBottomSummary from "./components/_FixedBottomSummary";
import BillingAddressForm from "./components/address/BillingAddressForm.jsx";
import SaveAddressModal from "./components/address/SaveAddressModal.jsx";
import ShippingAddressForm from "./components/address/ShippingAddressForm.jsx";
import {
  serializeCompareBilling,
  // serializeCompareShipping,
  serializeToBillingAddressState,
  serializeToBillingPayload,
  serializeToSavedAddressPayload,
  serializeToShippingAddressState,
  serializeToShippingPayload,
} from "./components/address/serde.js";
import {
  areObjectsEqual,
  fetchAllCartData,
  saveBillingAddressById,
  saveShippingAddressById,
} from "./components/address/utils.js";
import {
  getCartTotalPriceAsync,
  manageHasEventsAsync,
  resetMachineTestMode,
  selectCheckoutSteps,
  selectTotalPrice,
  setMachineTestSteps,
  stepsEnum,
} from "./store/checkoutSlice";
import {
  fetchAddresses,
  postAddress,
  updateAddress,
} from "./store/savedAddress.js";
import "./styles/bs-accordion.css";
import { set } from "date-fns";

const AddressPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const savedAddresses = useSelector((state) => state.address.addresses);

  const checkoutSteps = useSelector(selectCheckoutSteps);
  const totalPrice = useSelector(selectTotalPrice);

  const [tncBox, setTncBox] = useState(true);

  const [active, setActive] = useState("0");

  const [showShipping, setShowShipping] = useState(false);
  const [sameAsShipping, setSameAsShipping] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const [shippingAddressState, setShippingAddressState] = useState({});
  const shippingAddressFormRef = useRef();

  const [billingAddressState, setBillingAddressState] = useState({});
  const billingAddressFormRef = useRef();

  // save select saved address box for check update state
  const [selectedSavedAddress, setSelectedSavedAddress] = useState(null);
  // set shipping values for comparing to handle update
  // const [shippingAddressForCheck, setShippingAddressForCheck] = useState({});
  // set billing values for comparing to handle update
  // const [billingAddressForCheck, setBillingAddressForCheck] = useState({});

  const [activeKey, setActiveKey] = useState(null);

  useEffect(() => {
    const user_id = localStorage.getItem("user_id");
    if (user_id) {
      localStorage.removeItem("error");
    }
    // Guest users can now proceed to address page to enter shipping details
    
    // Clear the proceeding flag when address page mounts (user successfully navigated from eventDetails)
    localStorage.removeItem('event_checkout_proceeding');
    
    // Cleanup function: Remove events from cart if user backs out during checkout
    return () => {
      const removeEventsFromCart = async () => {
        try {
          // Check if user is proceeding to checkout page (not backing out)
          const isProceedingToCheckout = localStorage.getItem('address_proceeding_to_checkout');
          
          if (isProceedingToCheckout === 'true') {
            // User is proceeding to checkout page - don't remove events
            return;
          }

          // Check if checkout was completed successfully
          const checkoutInProgress = localStorage.getItem('event_checkout_in_progress');
          
          // If checkout is not in progress (payment successful), don't remove events
          if (checkoutInProgress !== 'true') {
            return;
          }

          // Don't remove events from address page - user should be able to navigate back and forth
          // Events will only be removed if user navigates away from the eventDetails page
          
          // Note: We don't clear the flags here to maintain checkout flow state
          // The flags will be cleared when payment is successful or user navigates completely away
        } catch (error) {
        }
      };
      
      // Execute cleanup
      removeEventsFromCart();
    };
  }, [])

  useEffect(() => {
    fetchAllCartData().then(({ cart, shipping, billing }) => {
      // console.log(cart, billing, shipping);
      setShowShipping(shipping);
      if (!shipping) {
        setActive("1");
        // Without shipping view checkbox state auto true
        setTncBox(true);
      }
    });
  }, []);

  useEffect(() => {
    // Check if cart contains machine tests to set appropriate steps
    const checkMachineTestsAndSetSteps = async () => {
      const user_id = localStorage.getItem("user_id");
      let hasMachineTests = false;
      
      if (user_id && user_id > 0) {
        // Logged-in user: check backend
        try {
          const machineTestItemsUrl = `${myConstClass.BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/en`;
          const machineTestItemsData = await (await fetch(machineTestItemsUrl)).json();
          hasMachineTests = machineTestItemsData.length > 0;
        } catch (error) {
        }
      } else {
        // Guest user: check localStorage
        const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
        hasMachineTests = guestEvents.some(event => event.event_type === 'Machine Test' || event.event_type_id === 3);
      }
      
      // Set appropriate steps based on cart contents
      if (hasMachineTests) {
        dispatch(setMachineTestSteps());
      } else {
        // Run regular event management for normal events
        dispatch(manageHasEventsAsync());
      }
      
      dispatch(getCartTotalPriceAsync());
      dispatch(fetchAddresses());
    };
    
    checkMachineTestsAndSetSteps();
    
    // Cleanup function to reset machine test mode when component unmounts
    return () => {
      dispatch(resetMachineTestMode());
    };
  }, [dispatch]);

  function compareAddresses() {
    try {
      // console.log("comparing");
      const _serdShipping =
        serializeToShippingAddressState(selectedSavedAddress);
      const _serdBilling = serializeToBillingAddressState(selectedSavedAddress);

      const _shippingEqual = areObjectsEqual(
        _serdShipping,
        shippingAddressState
      );
      // console.log(_serdShipping, shippingAddressState);

      const _billingEqual = areObjectsEqual(_serdBilling, billingAddressState);
      // console.log(_serdBilling, billingAddressState);

      // console.log({ _billingEqual, _shippingEqual });
      if (_billingEqual && _shippingEqual) {
        // console.log("no changes");
        return true;
      }

      return false;
    } catch (error) {
    }
  }

  async function createSavedAddress(label = "Home") {
    try {
      const _serdSavedAddressPayload = serializeToSavedAddressPayload(
        shippingAddressState,
        billingAddressState
      );
      _serdSavedAddressPayload.label = label;
      _serdSavedAddressPayload.user_id = localStorage.getItem("user_id");
      // console.log(_serdSavedAddressPayload);
      dispatch(postAddress(_serdSavedAddressPayload)).then(() => {
        dispatch(fetchAddresses());
        // console.log("Created saved address");
        history.push("/checkout");
        // console.log("Created saved address");
      });
    } catch (error) {
    }
  }

  async function updateSavedAddress() {
    try {
      // console.log("updateSavedAddress");
      const _serdSavedAddressPayload = serializeToSavedAddressPayload(
        shippingAddressState,
        billingAddressState
      );
      _serdSavedAddressPayload.id = selectedSavedAddress.id;
      _serdSavedAddressPayload.label = selectedSavedAddress.label;
      // console.log(_serdSavedAddressPayload);
      dispatch(updateAddress(_serdSavedAddressPayload)).then(() => {
        dispatch(fetchAddresses());
        // console.log("Updated saved address");
      });
    } catch (error) {
    }
  }

  async function saveAddresses() {
    try {
      const _shippingAddressPayload =
        serializeToShippingPayload(shippingAddressState);
      const _billingAddressPayload =
        serializeToBillingPayload(billingAddressState);
      // console.log(
      //   "state",
      //   { shippingAddressState, billingAddressState },
      //   "payloads",
      //   { _shippingAddressPayload, _billingAddressPayload }
      // );
      const [saveShipping, saveBilling] = await Promise.all([
        saveShippingAddressById(_shippingAddressPayload, (err, data) => {
          // console.log(err, data);
        }),
        saveBillingAddressById(_billingAddressPayload, (err, data) => {
          // console.log(err, data);
        }),
      ]);
      // console.log({ saveShipping, saveBilling });
    } catch (error) {
    }
  }

  // Helper function: Create guest user account
  async function createGuestUserAccount() {
    const guestBillingArray = JSON.parse(localStorage.getItem('guest_billing_address') || '[]');
    const guestShippingArray = JSON.parse(localStorage.getItem('guest_shipping_address') || '[]');
    
    // Convert to objects
    const guestBilling = {};
    guestBillingArray.forEach(item => {
      guestBilling[item.name] = item.value;
    });
    
    const guestShipping = {};
    guestShippingArray.forEach(item => {
      guestShipping[item.name] = item.value;
    });
    
    // Prepare guest user registration data
    const guestUserData = {
      userType: "guest",
      first_name: guestBilling.first_name || guestShipping.shipping_first_name || '',
      last_name: guestBilling.last_name || guestShipping.shipping_last_name || '',
      email: guestBilling.email || guestShipping.shipping_email || '',
      phone: guestBilling.phone || guestShipping.shipping_phone || ''
    };
    
    const response = await fetch(`${myConstClass.NODE_API_BASE}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(guestUserData)
    });
    
    const result = await response.json();
    
    if (result.status === 'true' && result.user_details && result.user_details.userId) {
      const userId = result.user_details.userId;
      return { user_id: userId, ...result };
    } else {
      throw new Error(result.message || 'Email already registered, please log in or use another email');
    }
  }

  // Helper function: Save guest addresses to database
  async function saveGuestAddressesToDB(user_id) {
    const guestBillingArray = JSON.parse(localStorage.getItem('guest_billing_address') || '[]');
    const guestShippingArray = JSON.parse(localStorage.getItem('guest_shipping_address') || '[]');
    
    // Convert to objects
    const guestBilling = {};
    guestBillingArray.forEach(item => {
      guestBilling[item.name] = item.value;
    });
    
    const guestShipping = {};
    guestShippingArray.forEach(item => {
      guestShipping[item.name] = item.value;
    });
    
    // Backend expects data in array of {name, value} format
    // Prepare billing address data (type = 1)
    const billingData = [
      { name: 'first_name', value: guestBilling.first_name || '' },
      { name: 'middle_name', value: guestBilling.middle_name || '' },
      { name: 'last_name', value: guestBilling.last_name || '' },
      { name: 'company', value: guestBilling.company || '' },
      { name: 'address_line_1', value: guestBilling.address_line_1 || '' },
      { name: 'address_line_2', value: guestBilling.address_line_2 || '' },
      { name: 'landmark', value: guestBilling.landmark || '' },
      { name: 'country', value: guestBilling.country || '101' },
      { name: 'state', value: guestBilling.state || '' },
      { name: 'city', value: guestBilling.city || '' },
      { name: 'pincode', value: guestBilling.pincode || '' },
      { name: 'phone', value: guestBilling.phone || '' },
      { name: 'email', value: guestBilling.email || '' },
      { name: 'customCheck2', value: '0' } // Magazine subscription checkbox
    ];
    
    // Prepare shipping address data (type = 2)
    const shippingData = [
      { name: 'shipping_first_name', value: guestShipping.shipping_first_name || guestBilling.first_name || '' },
      { name: 'shipping_middle_name', value: guestShipping.shipping_middle_name || guestBilling.middle_name || '' },
      { name: 'shipping_last_name', value: guestShipping.shipping_last_name || guestBilling.last_name || '' },
      { name: 'shipping_company', value: guestShipping.shipping_company || guestBilling.company || '' },
      { name: 'shipping_address_line_1', value: guestShipping.shipping_address_line_1 || guestBilling.address_line_1 || '' },
      { name: 'shipping_address_line_2', value: guestShipping.shipping_address_line_2 || guestBilling.address_line_2 || '' },
      { name: 'shipping_landmark', value: guestShipping.shipping_landmark || guestBilling.landmark || '' },
      { name: 'shipping_country', value: guestShipping.shipping_country || guestBilling.country || '101' },
      { name: 'shipping_state', value: guestShipping.shipping_state || guestBilling.state || '' },
      { name: 'shipping_city', value: guestShipping.shipping_city || guestBilling.city || '' },
      { name: 'shipping_pincode', value: guestShipping.shipping_pincode || guestBilling.pincode || '' },
      { name: 'shipping_phone', value: guestShipping.shipping_phone || guestBilling.phone || '' },
      { name: 'shipping_email', value: guestShipping.shipping_email || guestBilling.email || '' },
      { name: 'customCheck2', value: '0' } // Magazine subscription checkbox
    ];
    
    try {
      // Save billing address (type = 1)
      const billingResponse = await fetch(myConstClass.BASE_URL + `users/addAddress/1/${user_id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(billingData)
      });
      const billingResult = await billingResponse.json();
      
      // Save shipping address (type = 2)
      const shippingResponse = await fetch(myConstClass.BASE_URL + `users/addAddress/2/${user_id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(shippingData)
      });
      const shippingResult = await shippingResponse.json();
    } catch (error) {
      throw error;
    }
  }

  // Helper function: Transfer guest cart to user account in database
  async function transferGuestCartToUser(user_id) {
    const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
    const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
    const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
    
    try {
      // FIRST: Clear any existing cart items for this user (in case of old/stale data)
      const clearResponse = await fetch(myConstClass.BASE_URL + `cart/clearCart/${user_id}`, {
        method: 'GET'
      });
      await clearResponse.json();
      
      // Transfer products
      if (guestProducts.length > 0) {
        for (const product of guestProducts) {
          const response = await fetch(myConstClass.BASE_URL + `cart/addProductToCart/${product.product_id}/${product.quantity}/${user_id}`, {
            method: 'GET'
          });
          const result = await response.json();
          if (result.status !== 'true') {
          }
        }
      }
      
      // Transfer magazines
      if (guestMagazines.length > 0) {
        for (const magazine of guestMagazines) {
          const response = await fetch(myConstClass.BASE_URL + `cart/addMagazineToCart/${magazine.package_id}/${user_id}`, {
            method: 'GET'
          });
          const result = await response.json();
          if (result.status !== 'true') {
          }
        }
      }
      
      // Transfer events (machine tests stay in localStorage)
      if (guestEvents.length > 0) {
        for (const event of guestEvents) {
          // Check if this is a machine test event
          if (event.event_type === 'Machine Test' || event.event_type_id === 3) {
            // Machine tests now use localStorage for both guest and logged-in users
            // No backend transfer needed - they'll be processed from localStorage during checkout
          } else {
            // Use regular event API
            const response = await fetch(myConstClass.BASE_URL + `cart/addEventToCart/${event.schedule_id}/${user_id}/${event.parent}/${event.child || 0}`, {
              method: 'GET'
            });
            const result = await response.json();
            if (result.status !== 'true') {
            }
          }
        }
      }
      
    } catch (error) {
      throw new Error('Failed to transfer cart items: ' + error.message);
    }
  }

  async function handleNext() {
    try {
      const shippingValid = shippingAddressFormRef.current.validate();
      const billingValid = billingAddressFormRef.current.validate();

      if (!shippingValid || !billingValid) return;

      await saveAddresses();

      // Clear machine test localStorage values when proceeding to checkout
      localStorage.removeItem('current_schedule_id');
      localStorage.removeItem('current_topic_id');
      localStorage.removeItem('is_machine_test_flow');

      const user_id = localStorage.getItem("user_id");
      
      if (user_id && user_id > 0) {
        // Logged-in user: handle saved addresses
        if (selectedSavedAddress) {
          const compareEqual = compareAddresses();
          if (compareEqual) {
            // Mark that user is proceeding to checkout (not backing out)
            localStorage.setItem('address_proceeding_to_checkout', 'true');
            history.push("/checkout");
          } else {
            setShowModal(true);
          }
        } else {
          createSavedAddress().then(() => {
            // Mark that user is proceeding to checkout (not backing out)
            localStorage.setItem('address_proceeding_to_checkout', 'true');
            history.push("/checkout");
          });
        }
      } else {
        // Guest user: Create account, save addresses & cart to DB BEFORE checkout
        // NOTE: Guest user will NOT be "signed in" - they remain anonymous in the UI
        // Process silently without showing success messages to user
        
        try {
          const guestUserData = await createGuestUserAccount();
          
          if (!guestUserData || !guestUserData.user_id) {
            throw new Error('Email already registered, please log in or use another email');
          }
          
          await saveGuestAddressesToDB(guestUserData.user_id);
          
          await transferGuestCartToUser(guestUserData.user_id);
          
          // Store guest user data for API calls and email confirmation
          // Extract email and first_name from guest addresses
          const guestBillingArray = JSON.parse(localStorage.getItem('guest_billing_address') || '[]');
          const guestEmail = guestBillingArray.find(item => item.name === 'email')?.value || '';
          const guestFirstName = guestBillingArray.find(item => item.name === 'first_name')?.value || '';
          
          // IMPORTANT: Do NOT set 'user_id' for guest users to avoid showing logged-in UI
          // Use 'guest_user_id_temp' instead - payment and checkout will check for both
          localStorage.setItem('guest_user_id_temp', guestUserData.user_id);
          localStorage.setItem('guest_email', guestEmail); // For email confirmation
          localStorage.setItem('guest_first_name', guestFirstName); // For email confirmation
          localStorage.setItem('isGuestAutoCreated', 'true');
          
          // Mark that user is proceeding to checkout (not backing out)
          localStorage.setItem('address_proceeding_to_checkout', 'true');
          
          // Now proceed to checkout - user data is in database!
          history.push("/checkout");
          
        } catch (error) {
          toast.error('Failed to process your information. Please try again.', { autoClose: 3000 });
          throw error;
        }
      }
    } catch (error) {
    }
  }

  async function handleNextForBillingOnly() {
    try {
      const billingValid = billingAddressFormRef.current.validate();
      // console.log({ billingValid });
      if (!billingValid) return;
      await saveAddresses();
      
      // Clear machine test localStorage values when proceeding to checkout
      localStorage.removeItem('current_schedule_id');
      localStorage.removeItem('current_topic_id');
      localStorage.removeItem('is_machine_test_flow');
      
      const user_id = localStorage.getItem("user_id");
      
      if (user_id && user_id > 0) {
        // Logged-in user: proceed directly
        // Mark that user is proceeding to checkout (not backing out)
        localStorage.setItem('address_proceeding_to_checkout', 'true');
        history.push('/checkout');
      } else {
        // Guest user: Create account, save addresses & cart to DB BEFORE checkout
        // NOTE: Guest user will NOT be "signed in" - they remain anonymous in the UI
        // Process silently without showing success messages to user
        
        try {
          const guestUserData = await createGuestUserAccount();
          
          if (!guestUserData || !guestUserData.user_id) {
            throw new Error('Email already registered, please log in or use another email');
          }
          
          await saveGuestAddressesToDB(guestUserData.user_id);
          
          await transferGuestCartToUser(guestUserData.user_id);
          
          // Store guest user data for API calls and email confirmation
          // Extract email and first_name from guest addresses
          const guestBillingArrayBilling = JSON.parse(localStorage.getItem('guest_billing_address') || '[]');
          const guestEmailBilling = guestBillingArrayBilling.find(item => item.name === 'email')?.value || '';
          const guestFirstNameBilling = guestBillingArrayBilling.find(item => item.name === 'first_name')?.value || '';
          
          // IMPORTANT: Do NOT set 'user_id' for guest users to avoid showing logged-in UI
          // Use 'guest_user_id_temp' instead - payment and checkout will check for both
          localStorage.setItem('guest_user_id_temp', guestUserData.user_id);
          localStorage.setItem('guest_email', guestEmailBilling); // For email confirmation
          localStorage.setItem('guest_first_name', guestFirstNameBilling); // For email confirmation
          localStorage.setItem('isGuestAutoCreated', 'true');
          
          // Mark that user is proceeding to checkout (not backing out)
          localStorage.setItem('address_proceeding_to_checkout', 'true');
          
          // Now proceed to checkout - user data is in database!
          history.push("/checkout");
          
        } catch (error) {
          toast.error('Failed to process your information. Please try again.', { autoClose: 3000 });
          throw error;
        }
      }
    } catch (error) {
    }
  }

  return (
    <div className="position-relative">
      <ToastContainer />
      <NewHeader />

      <div className="mt-4 pt-2 mt-sm-4 pt-sm-4 mt-md-4 pt-md-4 mt-xl-1">
        <Stepper 
          steps={checkoutSteps} 
          currentStep={checkoutSteps.includes(stepsEnum[0]) ? stepsEnum[2] : stepsEnum[0]} 
        />
      </div>

      {/* <pre>{JSON.stringify(savedAddresses, null, 2)}</pre> */}
      {savedAddresses?.length > 0 && (
        <AddressCarousel
          savedAddresses={savedAddresses}
          // selectAddressId={selectAddressId}
          // handleDeleteAddress={handleDeleteAddress}
          // handleSetFormFields={handleSetFormFields}
          onSavedAddressSelect={(savedAddress) => {
            setSelectedSavedAddress(savedAddress);
            setShippingAddressState(
              serializeToShippingAddressState(savedAddress)
            );
            setBillingAddressState(
              serializeToBillingAddressState(savedAddress)
            );
          }}
        />
      )}

      {/* Events 
          Root
            Next Button onClick
              Submit 
                Selected Saved Address
                  Updated ? Modal
                              Create | Update
                Shipping/Billing Save 

          Nestesd
            Shipping/Billing Form onChange
            Same As Shipping Checkbox onChange

          */}

      <div className="custom-flex col-12 col-lg-12">
        <div className="accordion-container right-side">
          <Accordion
            className="container px-0"
            activeKey={active}
            onSelect={(e) => {
              setActive(e);
              setActiveKey(e);
            }}
          >
            {showShipping ? (
              <Accordion.Item eventKey="0" className="border-0">
                <Accordion.Header>
                  <h3 className="fw-bold">
                    <b>Shipping Address</b>
                  </h3>
                </Accordion.Header>
                <Accordion.Body>
                  <ShippingAddressForm
                    ref={shippingAddressFormRef}
                    shippingAddress={shippingAddressState}
                    onFormValueChange={(state) => {
                      // console.log("setting shipping", state);
                      setShippingAddressState(state);
                      // setShippingAddressForCheck(
                      //   serializeCompareShipping(state)
                      // );
                      if (sameAsShipping) {
                        // console.log({ billingAddressState, state });
                        delete state.type
                        setBillingAddressState(state);
                        // setBillingAddressForCheck(
                        //   serializeCompareBilling(state)
                        // );
                      }
                    }}
                    onTnCCheck={(check) => {
                      setTncBox(check);
                    }}
                    onSameAsShipping={(_sameAsShipping, state) => {
                      setSameAsShipping(_sameAsShipping);
                      if (_sameAsShipping && state) {
                         delete state.type
                        setBillingAddressState(state);
                      }
                      // setBillingAddressState(serialize(state));
                    }}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ) : null}

            {showShipping ? (
              <Accordion.Item eventKey="1" className="border-0 mt-1">
                <Accordion.Header>
                  <h3 className="fw-bold">
                    <b>Billing Address</b>
                  </h3>
                </Accordion.Header>
                <Accordion.Body>
                  <BillingAddressForm
                    ref={billingAddressFormRef}
                    sameAsShipping={sameAsShipping}
                    billingAddress={billingAddressState}
                    onFormValueChange={(state) => {
                      setBillingAddressState(state);
                      // setBillingAddressForCheck(serializeCompareBilling(state));
                    }}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <Accordion.Item eventKey="1" className="border-0 mt-1">
                <Accordion.Header>
                  <h3 className="fw-bold">
                    <b>Billing Address</b>
                  </h3>
                </Accordion.Header>
                <Accordion.Body>
                  <BillingAddressForm
                    ref={billingAddressFormRef}
                    sameAsShipping={sameAsShipping}
                    billingAddress={billingAddressState}
                    onFormValueChange={(state) => {
                      setBillingAddressState(state);
                      delete state.type
                      setShippingAddressState(state);
                    }}
                  />
                </Accordion.Body>
              </Accordion.Item>
            )}
          </Accordion>
        </div>
      </div>

      <FixedBottomSummary totalPrice={totalPrice}>
        <div>
          <button
            type="submit"
            form=""
            className="w-100 btn py-2 proceed-button text-nowrap"
            onClick={() => {
              if (showShipping) handleNext();
              else handleNextForBillingOnly();
            }}
            disabled={!tncBox}
          >
            <span className="mr-2">Next</span>{" "}
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      </FixedBottomSummary>

      <SaveAddressModal
        show={showModal}
        onUpdate={() => {
          updateSavedAddress();
          setShowModal(false);
          // console.log("update");
          // Mark that user is proceeding to checkout (not backing out)
          localStorage.setItem('address_proceeding_to_checkout', 'true');
          history.push("/checkout");
        }}
        onCreate={(label) => {
          createSavedAddress(label);
          setShowModal(false);
          // console.log("create");
          // Mark that user is proceeding to checkout (not backing out)
          localStorage.setItem('address_proceeding_to_checkout', 'true');
          history.push("/checkout");
        }}
      />

      <Footer />
    </div>
  );
};

export default AddressPage;